<app-device-features-container
  header="{{ title | translate }}"
  [overlayType]="overlayType"
  [deviceSelectId]="deviceSelectId"
  [class.no-features]="chartBarParts.length === 0"
>
  <mat-icon
    *ngIf="
      (installationDetailsStore.isInstallationLegacyHP$ | async) &&
      overlayType === availableOverlays.ElectricityConsumption
    "
    header
    matTooltip="{{
      '+INSTALLATIONS.INSTALLATION.ELECTRICITY_CONSUMPTION.ONLY_COMPRESSOR' | translate
    }}"
    matTooltipClass="multiline-tooltip"
  >
    warning_outline
  </mat-icon>
  <mat-icon
    *ngIf="tooltipInfo"
    header
    [matTooltip]="tooltipInfo"
    matTooltipClass="multiline-tooltip"
    >info</mat-icon
  >
  <div
    #container
    feature
    [ngClass]="{
      'charts-features-small': chartBarParts.length > 2,
      'charts-features-big': chartBarParts.length > 0 && 3 > chartBarParts.length,
      'charts-features-full': chartBarParts.length === 0
    }"
    class="chart-container"
  >
    <highcharts-chart
      feature
      data-at-generic-tile-chart
      [Highcharts]="highCharts"
      [constructorType]="'stockChart'"
      [options]="chartOptions"
      (chartInstance)="setChartInstance($event)"
    ></highcharts-chart>
  </div>
  <ng-container feature *ngFor="let barPart of chartBarParts">
    <app-feature-tile
      feature
      [class.full-width]="chartBarParts.length === 1"
      label="{{ barPart.designationKey | translate }}, {{ 'DATETIME.TODAY' | translate }}"
      value="{{ unitsAdapter.getDisplayValue(barPart.value, barPart.unit) }} {{
        unitsAdapter.getSuffix(barPart.unit)
      }}"
    ></app-feature-tile>
  </ng-container>
</app-device-features-container>
